module.exports = __webpack_public_path__ + "static/media/moimoilogo.b7df87cb.gif";